<div class="footer mat-caption-sm th-caption">
  <span><!-- offset element for flexbox --></span>
  <span class="copyright">
    {{ 'footer.copyright' | transloco }} &copy; {{ year }}
    <a href="https://zevaglobal.com/" target="_blank" class="link-neutral">{{ 'footer.company' | transloco }}</a>.
    {{ 'footer.rightsReserved' | transloco }} |
    <a routerLink="/terms-of-use" target="_blank" class="link-neutral">{{ 'Terms of Use' | transloco }}</a> |
    <a routerLink="/privacy-policy" target="_blank" class="link-neutral">{{ 'Privacy Policy' | transloco }}</a> |
    <a routerLink="/terms-of-service" target="_blank" class="link-neutral">{{ 'Terms of Service' | transloco }}</a>
  </span>
  <span class="version">{{ debug ? appVersion : '' }}</span>
</div>
